/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./myTile.vue?vue&type=template&id=4bcd0a10&scoped=true"
import script from "./myTile.vue?vue&type=script&lang=js"
export * from "./myTile.vue?vue&type=script&lang=js"
import style0 from "./myTile.vue?vue&type=style&index=0&id=4bcd0a10&prod&lang=css"
import style1 from "./myTile.vue?vue&type=style&index=1&id=4bcd0a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd0a10",
  null
  
)

export default component.exports